import { UIAsset } from '../../config/assets';
import { SObjectId } from '../mdl/s-object';

export function $cdn(path: string) {
    return 'https://cdn.abundolive.se/' + path;
}

export namespace $cdn {
    export const upload_url = '/service/media/v1/upload';

    export function media(object_id: SObjectId | UIAsset, variant?: string) {
        let path: string = 'download/' + object_id;
        if(variant)
            path += '-' + variant;
        return $cdn(path);
    }
}
